import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=7d521fee&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=7d521fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d521fee",
  null
  
)

export default component.exports